// extracted by mini-css-extract-plugin
export default {"Heading":"Heading27zX-jHftbp1"};